// @flow
import client, { deleteJWTToken } from '../../client'
import format from '../../utils/format'
import jwt from '../../utils/jwt'

// API Endpoints
export const USER_SUSPEND = '/auth/users/{0}/suspend_account/'

/**
 * Deactivates a user account. It suspends the user until further reactivation.
 * @return {Promise|Error} A resolved Promise with the boolean response or Rejected with an Error
 * @deprecated
 */
export const suspend = (): Promise<any> => {
  const userId = jwt.getAuthorizedUserId()
  const endpoint = format(USER_SUSPEND, userId)

  return client.post(endpoint, {}).then((response) => {
    deleteJWTToken()
    return response.success
  })
}

export default suspend
